export default __webpack_public_path__ + "static/media/Volton_ΗΛ.d43ee932.png";